import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Grid,
} from "@mui/material";

import { Trans } from "@lingui/macro";

import { withUseFormHook, } from "@sinossi/mates-react-library";

import * as Yup from "yup";

import MetadataSection from "./metadata-section/series-metadata-section";

import { ContentDescription, Series } from "models";
import { SegregationType } from "commons/form-constants";
import { SegregationSection } from "components/backoffice/content/create-and-edit-content-detail-form/segregation-section/segregation-section";

const DetailFormSchema = Yup.object().shape({
});

export interface CreateAndEditSeriesDetailFormProps {
    onDetailSubmit: (stepData: any) => void,
    series: Series | null,
    collectionsList: any
}

export interface CreateAndEditSeriesDetailFormState {
    isThumbUploaded: boolean,
    fileImg: any | null,
    fileImgName: string | null,
    fileImgURL: any,
    title: ContentDescription[],
    synopsis: ContentDescription[],
    formFlag: boolean,
    isThumbnailUpdated: boolean
}

class CreateAndEditSeriesDetailForm extends React.Component<CreateAndEditSeriesDetailFormProps & UseFormReturn, CreateAndEditSeriesDetailFormState> {

    constructor(props: any) {

        super(props);

        this.state = {
            isThumbUploaded: false,
            isThumbnailUpdated: false,
            formFlag: false,
            fileImgName: null,
            fileImg: null,
            fileImgURL: null,
            title: [],
            synopsis: []
        };

    }

    componentDidMount() {

        if (this.props.series !== null) {
            this.setFormDefaultValue();
        }

        this.setState(() => ({ formFlag: true }));
    }

    private setFormDefaultValue = () => {

        this.setState(() => ({
            title: this.props.series!.title,
            synopsis: this.props.series!.synopsis,
            fileImgName: this.props.series!.thumbnailData.fileName,
            fileImgURL: this.props.series!.thumbnailServingUrl,
            isThumbUploaded: true,
        }));


        this.props.setValue("metadata.director", this.props.series!.director.join(","));
        this.props.setValue("metadata.productionYear", this.props.series!.productionYear);

        let language = this.props.collectionsList.languageList.list.find((lan: any) => { return lan.isoCode === this.props.series!.language });
        this.props.setValue("metadata.language", language?.id);

        this.props.setValue("segregation.segregationType", this.props.series!.segregationType);
        this.props.setValue("segregation.price", this.props.series!.payPerViewSegregationAdditionalInfos?.price);
        this.props.setValue("segregation.currency", this.props.series!.payPerViewSegregationAdditionalInfos?.currency);
        this.props.setValue("segregation.rentalAvailabilityDays", this.props.series!.rentalAvailabilityDays);
    }


    private submitForm = (values: any) => {

        let stepData: any = {
            title: this.state.title,
            synopsis: this.state.synopsis,
            director: values.metadata.director ? values.metadata.director.split(",") : [],
            language: values.metadata.language,
            productionYear: values.metadata.productionYear,
            isThumbnailUpdated: this.state.isThumbnailUpdated
        };

        let language = this.props.collectionsList.languageList.list.find((lan: any) => { return lan.id === values.metadata.language });
        stepData.language = language?.isoCode;

        if (!this.props.series || this.state.isThumbnailUpdated) {
            stepData.thumbnailFile = this.state.fileImg;
        }

        if (!this.state.isThumbnailUpdated) {
            stepData.thumbnailFile = this.props.series?.thumbnailData;
        }

        if (this.props.series) {
            stepData.segregationType = values.segregation.segregationType;
            stepData.rentalAvailabilityDays = values.segregation.rentalAvailabilityDays

            if (values.segregation.segregationType === SegregationType.PAY_PER_VIEW) {
                stepData.payPerViewSegregationAdditionalInfos = {
                    price: values.segregation.price,
                    currency: values.segregation.currency
                };
            }
        }

        this.props.onDetailSubmit(stepData);
    };

    private parseFileImg = (event: any) => {

        this.setState(() => ({
            fileImg: event.target.files[0],
            fileImgName: event.target.files[0].name,
            fileImgURL: URL.createObjectURL(event.target.files[0]),
            isThumbUploaded: true,
            isThumbnailUpdated: true
        }));
    };

    private removeFileImg = () => {
        this.setState(() => ({
            fileImg: null,
            fileImgName: null,
            isThumbUploaded: false
        }));
    };

    private updadateSeriesTitleAndSynopsis = (titleList: ContentDescription[], synopsisList: ContentDescription[]) => {
        this.setState(() => ({
            title: titleList,
            synopsis: synopsisList
        }))
    }

    render() {
        return (
            <Box>
                {this.state.formFlag && <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                    <Grid container>
                        {/* **************** METADATA CONTAINER **************** */}
                        <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                            <MetadataSection
                                name="metadata"
                                fileImgName={this.state.fileImgName}
                                fileImgURL={this.state.fileImgURL}
                                isThumbUploaded={this.state.isThumbUploaded}
                                removeFileImg={this.removeFileImg}
                                parseFileImg={this.parseFileImg}
                                title={this.state.title}
                                synopsis={this.state.synopsis}
                                updateTitleAndSynopsis={this.updadateSeriesTitleAndSynopsis}
                                {...this.props} />
                        </Grid>
                        {this.props.series !== null && <Grid item
                            xs={12}
                            p={3}
                            mt={2}
                            borderRadius="5px"
                            bgcolor={process.env.REACT_APP_THIRD_COLOR}>
                            <SegregationSection
                                name="segregation"
                                hasAvailabilityDays
                                {...this.props} />
                        </Grid>}

                        {/* **************** BUTTON **************** */}
                        <Grid item
                            xs={12}
                            mt={2}
                            textAlign={"right"} >
                            <Button
                                variant="contained"
                                color={"primary"}
                                disabled={this.props.formState.isSubmitting}
                                type="submit">
                                {this.props.series ?
                                    <Trans id="df-submit-edit-button">Modifica</Trans> :
                                    <Trans id="df-submit-create-button">Avanti</Trans>}
                            </Button>
                        </Grid>
                    </Grid>
                </form>}
            </Box>
        );
    }

}

export default withUseFormHook<{}>(CreateAndEditSeriesDetailForm, DetailFormSchema, {});
